import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/table";
import { Alert, AlertDescription } from "@/components/alert";
import Footer from '../../../components/Footer';
import MtechImg from "../../../assets/images/engineering.jpeg";

const programDetails = {
  name: "M.Tech in Artificial Intelligence Machine Learning and Engineering",
  about: "M.Tech. (Master of Technology) in Artificial Intelligence and Machine Learning is a postgraduate degree program that focuses on various machine learning algorithms and techniques for building predictive models from data. Topics may include supervised learning, unsupervised learning, reinforcement learning, neural networks, and deep learning. This course provides an introduction to the principles, methodologies, and applications of artificial intelligence. Students learn about technologies and platforms for processing, analyzing, and deriving insights from large-scale datasets.",
  eligibility: "Bachelor degree in Engineering/Technology or equivalent or a Master degree in Science/MDU Entrance examination",
};

const programFees = {
  program: "Master of Technology (M.Tech)",
  branch: "Artificial Intelligence and Machine Learning",
  duration: "2",
  seats: "20",
  // registrationFee: "16000",
  // allIndiaFee: "100000",
  // ukDomicileFee: "75000"
};

const scholarships = [
  { id: 1, type: "Single Girl Child", category: "", percentage: "10%", applicable: "All Years" },
  { id: 2, type: "Merit Based", category: "75%-80%", percentage: "20%", applicable: "*" },
  { id: 3, type: "Merit Based", category: "80%-90%", percentage: "30%", applicable: "*" },
  { id: 4, type: "Merit Based", category: "90%-95%", percentage: "50%", applicable: "*" },
  { id: 5, type: "Merit Based", category: "95%-100%", percentage: "70%", applicable: "*" },
  { id: 6, type: "For Hill States", category: "", percentage: "15%", applicable: "All Years" },
  { id: 7, type: "Martyrs/Defence Scholarship", category: "", percentage: "20%", applicable: "All Years" },
  { id: 8, type: "Sport Quota Scholarship", category: "State", percentage: "25%", applicable: "All Years" },
  { id: 9, type: "Sport Quota Scholarship", category: "National", percentage: "35%", applicable: "All Years" },
  { id: 10, type: "Sport Quota Scholarship", category: "International", percentage: "50%", applicable: "All Years" },
  { id: 11, type: "Disabled Student Scholarship", category: "", percentage: "40%", applicable: "All Years" },
  { id: 12, type: "Siblings Scholarship", category: "", percentage: "25%", applicable: "**" },
  { id: 13, type: "Early Bird till 8th June", category: "", percentage: "40%", applicable: "*" },
];

const MtechAIML = () => {
  return (
    <div className="w-full relative font-poppins">
      <div className="w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-5 md:gap-5">
        <Card>
          <CardHeader>
            <CardTitle className="text-2xl md:text-6xl tracking-tight font-bold text-center text-[#0e4d38]">
              {programDetails.name}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex flex-col md:flex-row gap-8 mb-10 md:gap-[80px] mt-5 justify-center md:justify-between">
              <img src={MtechImg} className="md:w-[40%] rounded-lg" alt="M.Tech AI & ML" />
              <div className="flex flex-col gap-4">
                <h4 className="font-bold text-xl md:text-3xl">About the Department</h4>
                <p className="text-justify md:text-lg">{programDetails.about}</p>
                <Link to="https://admission.maya.edu.in/">
                  <button className="mt-5 md:mt-0 bg-[#23376c] px-4 py-2 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3]">
                    Register Now
                  </button>
                </Link>
              </div>
            </div>
          </CardContent>
        </Card>

        <div className="mt-5">
          <h4 className="text-2xl font-semibold text-[#0e4d38]">Eligibility Criteria</h4>
          <p>{programDetails.eligibility}</p>
        </div>

        {/* Program Fee Table */}
        <div className="mt-10 overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="bg-[#23376c] text-white">
                <TableHead>Programme</TableHead>
                <TableHead>Branch</TableHead>
                <TableHead>Duration</TableHead>
                <TableHead>Seats</TableHead>
                {/* <TableHead>Registration Fee</TableHead>
                <TableHead>Yearly Fee (All India)</TableHead>
                <TableHead>Yearly Fee (UK Domicile)</TableHead> */}
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell>{programFees.program}</TableCell>
                <TableCell>{programFees.branch}</TableCell>
                <TableCell>{programFees.duration}</TableCell>
                <TableCell>{programFees.seats}</TableCell>
                {/* <TableCell>{`Rs.${programFees.registrationFee}/-`}</TableCell>
                <TableCell>{`Rs.${programFees.allIndiaFee}/-`}</TableCell>
                <TableCell>{`Rs.${programFees.ukDomicileFee}/-`}</TableCell> */}
              </TableRow>
            </TableBody>
          </Table>
        </div>

        {/* Scholarship Table */}
        <div className="mt-10 overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow className="bg-[#23376c] text-white">
                <TableHead>Sr. No</TableHead>
                <TableHead>Particulars</TableHead>
                <TableHead>Category</TableHead>
                <TableHead>Percentage</TableHead>
                <TableHead>Applicable</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {scholarships.map((scholarship) => (
                <TableRow key={scholarship.id}>
                  <TableCell>{scholarship.id}</TableCell>
                  <TableCell>{scholarship.type}</TableCell>
                  <TableCell>{scholarship.category}</TableCell>
                  <TableCell>{scholarship.percentage}</TableCell>
                  <TableCell>{scholarship.applicable}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>

        {/* Notes Section */}
        <Alert className="mt-10 bg-[#23376c]">
          <AlertDescription className="text-white italic font-semibold">
            * From 2nd year scholarship will be offered only on 75% attendance in the previous year with no back paper and no misconduct.
          </AlertDescription>
          <AlertDescription className="text-white italic font-semibold">
            ** Applicable on those courses whose fees will be less compared to other siblings.
          </AlertDescription>
        </Alert>
      </div>
      <Footer />
    </div>
  );
};

export default MtechAIML;
